export default __webpack_public_path__ + "static/media/13.bac75b8d.jpg";